import styled from 'styled-components'
import PropTypes from 'prop-types'
import { t } from 'ttag'

import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Text } from '@h2/components/typography/text'
import { ProgressBar } from '@h2/components/display/progressBar'
import { WarningIcon } from '@h2/components/icons/warning'
import { SG, SY, SO40S, SLB40S, SY40S } from '@h2/components/colors'

const FlexInner = styled(Flex)`
  span[role='img'] {
    margin-right: 3px;
  }

  > div {
    min-width: 0;

    p {
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        font-size: 12px;
        line-height: 12px;
      }
    }
  }

  & + div {
    margin-top: 2px;
  }
`
const getDescColorsIcon = ({ isStarted, isSubmitted, pctCompleted }) => {
  if (!isStarted) {
    return [t`You have a new assignment`, SLB40S, '', null]
  }

  if (pctCompleted === 100 && !isSubmitted) {
    return [t`assignment is complete, but not yet submitted`, SO40S, SG, WarningIcon]
  }

  return [t`Continue your assignment`, SY40S, SY, null]
}
const Lesson = ({ lesson }) => {
  const { name, isStarted, pctCompleted } = lesson
  const [desc, descColor, progressColor, Icon] = getDescColorsIcon(lesson)

  return (
    <Flex direction="column">
      <FlexInner alignItems="center">
        {Icon && <Icon />}
        <Box>
          <Text transform="uppercase" color={descColor} size="extraSmall" weight="bold">
            {desc}
          </Text>
          <Text>{name}</Text>
        </Box>
      </FlexInner>
      {isStarted && <ProgressBar value={pctCompleted || 0} color={progressColor} />}
    </Flex>
  )
}

Lesson.propTypes = {
  lesson: PropTypes.object.isRequired
}

export { Lesson }
